// Single source for WhatsApp contact details used across the site.
export const WHATSAPP_NUMBER = '+94762172756';

export const DEFAULT_WHATSAPP_MESSAGE =
  'Hello! I\'m interested in your Ceylon Cinnamon products. Can you help me?';

// wa.me links take the number as digits only, without the leading +
export const whatsappLink = (message = DEFAULT_WHATSAPP_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
